export default "__VITE_ASSET__CGLEnCpI__"